import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, Renderer2 } from '@angular/core';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';

@Directive({
    selector: '[toggle]',
    standalone: true
})
export class ToggleDirective implements AfterViewInit, OnDestroy {
    @Input({
        required: true
    })
    toggle!: NToggle.TId;

    @Input()
    toggleOff?: boolean;

    @Input()
    toggleOn: NToggle.EEventName = 'click';

    @Input()
    toggleOpenOptions?: NToggle.IOpenOptions;

    @Input()
    toggleCloseOptions?: NToggle.ICloseOptions;

    private _mouseEnterListen?: () => void;
    private _mouseOutListen?: () => void;
    private _clickListen?: () => void;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private toggleService: ToggleService
    ) {}

    ngAfterViewInit(): void {
        switch (this.toggleOn) {
            case 'hover':
                this._mouseEnterListen = this.renderer.listen(this.elementRef.nativeElement, 'mouseenter', event => {
                    if (!this.toggleOff) {
                        this.toggleService.open(this.toggle, this.toggleOpenOptions);
                    }
                });

                this._mouseOutListen = this.renderer.listen(this.elementRef.nativeElement, 'mouseleave', event => {
                    if (!this.toggleOff) {
                        this.toggleService.close(this.toggle, this.toggleCloseOptions);
                    }
                });

                break;
            default:
                this._clickListen = this.renderer.listen(this.elementRef.nativeElement, 'click', () => {
                    if (!this.toggleOff) {
                        this.toggleService.toggle(this.toggle);
                    }
                });

                break;
        }
    }

    ngOnDestroy(): void {
        this._mouseEnterListen && this._mouseEnterListen();
        this._mouseOutListen && this._mouseOutListen();
        this._clickListen && this._clickListen();
    }
}
